import { makeStyles } from 'tss-react/mui';

const useNoResultsEmptyStateStyles = makeStyles()((theme) => ({
  content: {
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    textAlign: 'center',
    '& .MuiStack-root': {
      alignItems: 'center',
    },
  },
}));

export default useNoResultsEmptyStateStyles;
